module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('img', {
    attrs: {
      "alt": "VT_logo.tif",
      "src": "images/VT_logo_fmt.jpeg"
    }
  }), _vm._v(" Everything Vegan")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/9780470547885f01"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/9780470547885f02"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/9780470547885f03"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/9780470547885f04"
    }
  }, [_vm._v("Cooking and Prep Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/9780470547885f05"
    }
  }, [_vm._v("Menu Ideas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Starters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Red Pepper Crostini With Balsamic Reduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wild Mushroom Bruschetta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wine-Braised Leeks Over Garlic Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Garlic Hummus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muhammara")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Lentil–Pecan Pâté")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Onion Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eggplant Caviar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlicky Spinach Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Olive Tapenade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artichoke Tapenade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Asparagus Tapenade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chive And Walnut \"Cheese\" Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar Cheeze")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pepper-Crusted Cashew \"Goat\" Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almond \"Feta\" Cheese With Herb Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Tempura With Chile Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lebanese Chickpea Croquettes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Grape Leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warm Pitas With Dukka")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunny Raw Nori Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Avocado Vietnamese Summer Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oaxacan Clayudas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perfect Steamed Artichokes À La Française")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c01#c01-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New World Party Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Drinks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Smoothie Base")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Hot Chocolate Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Avocado Frappé Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chai Cooler Smoothie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sorrel Drink")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Ginger Ale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watermelon Slushies (For Grown-Ups)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Citrus Basil Cocktail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dutch-Style Mulled Wine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c02#c02-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rich And Creamy Eggnog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Burgers and Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Bean And Watercress Tartines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Veggie Club Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paprika Cauliflower Pita Pockets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Reubens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meatless \"Meatloaf\" Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creepy Halloween \"Finger\" Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pulled \"Pork\" BBQ Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh-Mushroom Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gluten-Free Veggie Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Portobello Mushroom Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c03#c03-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greek-Style Lentil Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Salads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunshine Spinach Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Snap Pea Salad With Lemon-Mint Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Radicchio, Radish, And Fennel Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Fig And Artichoke Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italian Garden Salad With Artichokes And Fava Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taste Of Autumn Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberry-Pecan Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Vegetable Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pita Panzanella")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn And Mung Bean Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sea Palm Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mock Green Papaya Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deep South Slaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collard Green Coleslaw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Beets And Parsnips With Black Olives And Oranges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beet Green–Tangerine Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potato And Edamame Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Potato Salad With Apple And Avocado")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c04#c04-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Portobello-Potato Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Pasta and Noodles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spaghetti With Sautéed Leeks, White Beans, And Walnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quinoa Fettuccine In Mushroom Broth With Truffle Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Penne With Caramelized Cauliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Tomato Farfalle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spaghetti With Roasted Broccoli \"Pesto\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fettuccine With Three-Herb Pesto, Black Kale, And Oyster Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orzo With Peas And Asparagus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stir-Fried Udon With Bok Choy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chilled Noodle Salad With Mango")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soba Salad With Miso Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Gyoza And Edamame Succotash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c05#c05-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultimate Vegan Lasagna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Rice and Whole Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confetti Rice Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forbidden Rice Stove-Top Bibimbap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basmati And Wild Rice Over Acorn Squash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("East-West Risotto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butternut Squash Risotto With Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Paella With Tofu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maki Garden Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scattered Brown Rice Sushi Bowls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barley Risotto With Spinach And Tofu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twice-Cooked Polenta Wedges With Black-Eyed Pea Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Cooker Irish Oatmeal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Casablanca Quinoa Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Breakfast Quinoa With Dried Fruit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savory Tofu And Vegetables Over Tomato Couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bulgur With Curried Potatoes And Peas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemony Bulgur With Asparagus And Spinach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c06#c06-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Israeli Couscous With Carrots And Raisins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Tofu, Tempeh, and Seitan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southwestern Tofu Scramble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu Frittata With Zucchini And Onion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fiery Tofu With Red Chiles, Orange, And Ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broiled Tofu And Steamed Mustard Greens With Spicy Mango Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu Cutlets With Cilantro Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu Baked With Peanut Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu With Olives And Preserved Lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preserved Lemons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crispy Tofu Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chilled Tofu Salad With Ginger, Green Onions, Asparagus, And Sesame")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Barbecued Tofu And Corn Salad With Cilantro Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Sesame-Tofu Skewers With Ginger Peanut Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Bourguignonne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jamaican Tempeh Patties")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thai Golden Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tempeh Larb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kung Pao Tempeh Triangles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Seitan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\"Meat\" Balls And Spaghetti")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seitan Satay With Peanut Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seitan With Shiitake Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curried Seitan Salad Pita Pockets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braised Seitan Cutlets In Mushroom And Red Wine Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c07#c07-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seitan Jambalaya")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("North Indian Spiced Cabbage, Fennel, And Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Sausage And Turnip Green Ragoût")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hoppin' John With Collard Greens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steamed Greens With Sliced Leeks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sephardic Stuffed Cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet-And-Sour Red Cabbage With Apples And Tempeh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Callaloo With Hot Pepper Vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colcannon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlicky Oven Fries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curried Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Leek And Sweet Potato Gratin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Sweet Potato Wedges With Broccoli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegan Moussaka")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potato Latkes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pickled Daikon Cubes With Carrots And Jalapeños")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Cucumber Pickles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edamame Succotash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asparagus With Vegan Hollandaise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carciofi Alla Romana ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Roman-Style Braised Artichokes")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Sautéed Oyster Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Broccoli With Black Bean Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Beans With Walnuts And Shallot Crisps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Best-Ever Basic Roasted Veggie Recipe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Winter Squash With Spicy Maple Chestnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chestnut Stuffing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brussels Sprouts With Walnuts And Dried Cranberries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c08#c08-rcu-0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Vegetable Cornucopias With Gravy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Easy Beans and Lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chickpea Tacos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chickpea Stew With Couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refried Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beans And Bratwurst")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adzuki Beans And Winter Squash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Baked Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Beans With Oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Black-Eyed Pea Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indian Lentil Pilaf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curried Lentils With Cauliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c09#c09-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moroccan Pumpkin And Lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Soups and Stews")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cold Carrot-Ginger Bisque")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green-And-Gold Gazpacho")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mexican Rice Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("\"Wild\" Mushroom Soup With Sage And Croutons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Corn Chowder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sherried Kabocha Soup With Spiced Pepitas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quinoa And Spinach Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soupe Au Pistou")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fresh Pea Soup With Tarragon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Apple-Potato Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curried White Bean And Kale Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chard And Pearl Barley Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moroccan Harira")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pho ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Vietnamese Noodle Soup")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curry-Kuri Squash Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Root Vegetable Chili Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italian Eggplant Ragoût With Capers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Italian Wedding Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braised Lebanese Eggplant With Chickpeas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vietnamese Hot Pot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thai Red Curry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixed Vegetable Masala")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miso-Adzuki Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spring Vegetable Stew With Soft Polenta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetable Gumbo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chili Sin (Without) Carne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Cooker Vegetable Vindaloo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c10#c10-rcu-0029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southwestern Spinach Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Baked Goodies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Rye Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole-Wheat Rosemary Focaccia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super-Flax Whole-Wheat Boule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunset Sweet Potato Drop Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Flatbread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon-Raspberry Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Corn Cornbread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chip–Banana Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morning Glory Loaf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c11#c11-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry-Apple Tea Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Sweet Treats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thumbprint Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Heart Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kourabiedes ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Almond Shortbread Crescents")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snickerdoodles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glazed Raisin-Almond Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter–Oatmeal Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iced Ginger Gems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Shortbread Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Heart-Healthiest Chocolate Chip Cookies In The World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dark Chocolate Nuggets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fudgy Brownies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Truffles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Strawberry Compote With Vanilla Bean")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Pound Cake With Lime Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Spice Cupcakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raw Cashew Cheesecake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glazed Chocolate-Avocado Cupcakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Layer Cake With Peanut Butter Filling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triple Nut Chocolate Tart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberry-Cherry Lattice Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perfect Every Time Piecrust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple-Cinnamon Tarte Tatin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu Custard Tart With Fresh Fruit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Cardamom Rice Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three-Cherry Crumble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tropsicles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peaches-And-Cream Pops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pomegranate-Pineapple Granita")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter–Coconut Ice Creams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Swirl Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super Chocolate Vegan Gelato")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Açai Sorbet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tulip Cones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c12#c12-rcu-0035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roasted Maple Pecans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Sauces, Dips, Spreads, Jams, and Marinades")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speedy Red Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Gravy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arugula Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coffee Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Onion Confit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Cranberry Chutney")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple-Miso Sambal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple-Mustard Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberry-Sesame Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tarragon Mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Chile Mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jalapeño-Orange Dipping Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange-Hazelnut Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tzatziki Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mango Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ginger-Pear Jam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Kiwi Jam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fantastic Fig Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tangy Tomato Jam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Korean BBQ Marinade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mediterranean Marinade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet-And-Sour Sherry Vinegar Marinade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-head-1"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885c13#c13-rcu-0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South-Of-The-Border Marinade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/9780470547885a01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0